window.addEventListener("DOMContentLoaded", function() { 

    if(Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
            if (e.target.dataset.shopifyEditorSection.includes('blog')) {
                init()
            }
        })
    }
    init()
    function init() {
        const showTags = document.querySelector('#showTags').dataset.showTags

        if (showTags == 'true') {
    
            const floatyBtn = document.querySelectorAll('.floatyBtn')
            const blogTagsList = document.querySelector('.blogTagsList')
            const btnWrap = document.querySelector('.tagControlsWrap')

            let init = 0
    
            let newPos
    
            floatyBtn.forEach(btn => {
                btn.addEventListener('click', scrollTags)
            })
    
            if(blogTagsList.clientWidth >= document.querySelector('.blogHeader').clientWidth - 40) {
                btnWrap.classList.remove('displayNone')
            }

            const debListener = () => {
                let timerId 
                return () => {
                    clearTimeout(timerId)
                    timerId = setTimeout(() => {
                        if(blogTagsList.clientWidth <= document.querySelector('.blogHeader').clientWidth - 40) {
                            btnWrap.classList.add('displayNone')
                            init = 0
                            animate()
                        } else {
                            btnWrap.classList.remove('displayNone')
                            init = 0
                            animate()
                        }                        
                    }, 200);
                }
            }

            window.addEventListener('resize', debListener())
    
            function scrollTags(e) {
                const dir = e.currentTarget.dataset.controlElement
                tagScrollAnim(dir)
            }
    
            
            function tagScrollAnim(dir) {
    
                const blogHeader = document.querySelector('.blogHeader')
                newPos = document.querySelector('.blogHeader').clientWidth / 2
    
                if(dir == 'right') {
                    if(blogHeader.clientWidth + 40 >= blogTagsList.clientWidth) {
                        return
                    }
                    if (init + newPos >= blogTagsList.clientWidth - blogHeader.clientWidth) {
                        init = blogTagsList.clientWidth - blogHeader.clientWidth + 40
                    } else {
                        init += newPos
                    }
                } else if (dir == 'left') {
                    if (init - newPos <= 0) {
                        init = 0
                    } else {                
                        init -= newPos
                    }
                }
                
                animate()
            } 
    
            function animate() {
                const anim = [
                    {transform: `translateX(-${init}px)`}
                ]
    
                const options = {
                    duration: 500,
                    fill: 'forwards'
                }
    
    
                let animation = blogTagsList.animate(anim, options)
                animation.addEventListener('finish', () => {
                    blogTagsList.style.transform = `translateX(-${newPos}px)`
                })
            }
        
        }
    
    
        // filter by tags
    
        const blogSectionId = document.querySelector('#blogSectionId').dataset.id
        const grid = document.querySelector('.blogGrid')
        const blogPaginationWrap = document.querySelector('.blogPaginationWrap')
        const blogName = document.querySelector('#blogName').dataset.blogName
        const accentIconWrap = document.querySelectorAll('.accentIconWrap')
    
    
        const tagBtn = document.querySelectorAll('.tagBtn')
        tagBtn.forEach(btn => {
            btn.addEventListener('click', handleTag)
        })
    
        gridOneRes(grid.children.length)
    
        showCurrentTag()
        function showCurrentTag() {
    
            if(document.querySelector('.btnActive')) {
                document.querySelector('.btnActive').classList.remove('btnActive')
            }
    
            if(window.location.pathname.includes('tagged')) {
                let splitUrl = window.location.pathname.split('/')
        
                for (let i = 0; i < splitUrl.length; i++) {
                    if(splitUrl[i].includes('tagged')) {
                        for(let j = 0; j < tagBtn.length; j++) {
                            if (tagBtn[j].dataset.tag == splitUrl[i + 1]) {
                                tagBtn[j].classList.add('btnActive')
                            }
                        }        
                    }   
                }
        
            } else {
                if(showTags == 'true') {
                    tagBtn[0].classList.add('btnActive')
                }
            }
        }
    
        blogPaginationWrap.addEventListener('click', handlePagination)
    
        let currentTag = ''
        let currentPage = ''
        let pageChange = false 
    
    
        window.addEventListener('popstate', (e) => {
            e.preventDefault()
            if (history.state) {
                if(currentPage != history.state.currentPage) {pageChange = true}
                currentTag = history.state.currentTag
                currentPage = history.state.currentPage
            } else {
                currentPage = ''
                currentTag = ''
            }
    
            makeRequest(false)
            showCurrentTag()
        })
    
        function handlePagination(e) {
            e.preventDefault()
            pageChange = true
            if (e.target.classList.contains('navElement')) {
                let pageNumber
    
                e.target.href.split('&').forEach(str => {
                    if(str.includes('page')) {
                        pageNumber = str.split('=')[1]
                    }
                })
                currentPage = `page=${pageNumber}`
                makeRequest(true)
            }
    
        }
    
        function handleTag(e) {
            currentPage = ''
            let tag = e.currentTarget.dataset.tag
    
            currentTag = tag
    
            document.querySelector('.btnActive').classList.remove('btnActive')
            e.currentTarget.classList.add('btnActive')
    
            makeRequest(true)
    
        } 
    
        async function makeRequest(pushToHistory) {
            showLoading('show')
            let tagQ = ''
            let pageQ = ''
    
            if(currentTag) {
                tagQ = `/tagged/${currentTag}`
            }
    
            if(currentPage) {
                pageQ = `&${currentPage}`
            }
    
            let url = `${window.Shopify.routes.root}blogs/${blogName}${tagQ}?section_id=${blogSectionId}${pageQ}`
            let historyUrl = `${window.Shopify.routes.root}blogs/${blogName}${tagQ}?${currentPage}` 
    
            const res = await fetch(url);
            const text = await res.text();
            const dom = new DOMParser().parseFromString(text, 'text/html')
    
            updateDom(dom)
            if(pushToHistory) {
                history.pushState({currentPage, currentTag}, '', historyUrl)
            }
            showLoading('hide')
    
        }
    
        function updateDom (dom) {
            grid.innerHTML = ''
            blogPaginationWrap.innerHTML = ''
    
            blogPaginationWrap.append(dom.querySelector('.blogPaginationWrap').children[0])
    
            let newArticles = dom.querySelectorAll('.articleWrap') 
    
            newArticles.forEach(article => {
                grid.append(article)    
            })
    
    
            if(pageChange) {
                window.scrollTo({
                    top: document.querySelector('#blogs').offsetTop - 65,                
                    behavior: 'smooth'
                  });
    
                  pageChange = false 
            }
    
            gridOneRes(newArticles.length)
    
        }
    
        function gridOneRes(numberOfArticles) {
            if (numberOfArticles == 1) {
                grid.style = "grid-template-columns: 1fr; max-width: 640px"
            } else {
                grid.style = ""
            }
        }
    
        function showLoading(action) {
            if(showTags == 'false') { return }
            if(action == 'show') {
                accentIconWrap[0].classList.add('displayNone')
                accentIconWrap[1].classList.remove('displayNone')
            } else if (action == 'hide') {
                accentIconWrap[0].classList.remove('displayNone')
                accentIconWrap[1].classList.add('displayNone')
            }  
        }
    
    }

  
});
